export default __webpack_public_path__ + "static/media/check-in-banner-id.724ffe7b.webp";